<template>
  <div>
    <v-container class="pt-3 pb-6 px-6">
      
      <!-- Floating Button -->
      <floating-button @click="sensorsBoxCreate()" v-if="authUser"/>

      <!-- Confirmation -->
      <confirmation
        v-if="authUser"
        v-model="dialog"
        title="Eliminar Caja Sensores"
        text="Desea eliminar la caja sensores"
        :item="sensorsBoxToDelete.name"
        @close="dialog = false"
        @confirm="deleteSensorsBox()"
      />

      <!-- Page Header -->
      <page-header
        title="Cajas de Sensores"
        icon="mdi-cube-outline"
        divider="-"
        :breadcrumbs="breadcrumbs.items"
        refresh
        v-on:refresh="loadSensorsBoxes()"
      ></page-header>

      <!-- Content -->
      <v-row align="center" justify="center">
        <!-- Table -->
        <v-col cols="12">
          <!-- Loading Bar -->
          <v-progress-linear
            indeterminate
            v-if="isLoadingData"
          ></v-progress-linear>
          <!-- Table -->
          <v-data-table
            v-show="authUser"
            :headers="headers"
            :items="filteredSensorsBoxes"
            :items-per-page="5"
            class="elevation-1"
            :search="filterInput"
            :footer-props="{
              'items-per-page-options': [5, 15, 30, 50]
            }"
          >
            <!-- Top -->
            <template v-slot:top>
              <v-toolbar flat color="white">
                <!-- State Filter -->
                <v-select
                  v-model="filterState"
                  :items="stateItems"
                  class="shrink mr-5"
                  label="Estado"
                  clearable
                  hide-details
                  single-line
                ></v-select>
                <!-- Input Filter -->
                <v-text-field
                  v-model="filterInput"
                  class="grow"
                  label="Buscar..."
                  prepend-icon="mdi-magnify"
                  clearable
                  single-line
                  hide-details 
                ></v-text-field>
              </v-toolbar>
            </template>
            <!-- Actions -->
            <template v-slot:item.action="{ item }">
              <v-icon class="mr-2" @click="sensorsBoxData(item.id)">mdi-eye</v-icon>
              <span>
                <v-icon class="mr-2" @click="sensorsBoxEdit(item.id)">mdi-pencil</v-icon>
                <v-icon @click="deleteSensorsBoxDialog(item)">mdi-delete</v-icon>
              </span>
            </template>
            <!-- State -->
            <template v-slot:item.is_active="{ item }">
              <v-chip
                :color="item.is_active ? 'primary' : 'deep-orange'"
                :class="{'white--text': !item.is_active}"
              >{{ item.is_active ? 'Activo' : 'Inactivo' }}</v-chip>
            </template>
            <!-- No Data -->
            <template v-slot:no-data>
              No hay elementos
            </template>
            <!-- No Results -->
            <template v-slot:no-results>
              No hay elementos
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FloatingButton from "@/components/FloatingButton";
import Confirmation from "@/components/Confirmation";
import PageHeader from "@/components/PageHeader";
import Util from "@/util/index";

export default {
  components: {
    FloatingButton,
    Confirmation,
    PageHeader
  },
  data: () => ({
    authUser: false,
    isLoadingData: false,
    dialog: false,
    sensorsBoxToDelete: {},
    filterInput: '',
    filterState: null,
    stateItems: [
      { text: 'Activo', value: 'true' },
      { text: 'Inactivo', value: 'false' }
    ],
    headers: [
      { text: 'Nombre', align: 'center', sortable: true, value: 'name' },
      { text: 'Dirección MAC', align: 'center', sortable: true, value: 'mac_address' },
      { text: 'Estado', align: 'center', sortable: true, value: 'is_active' },
      { text: 'Acción', align: 'center', sortable: false, value: 'action' }
    ],
    breadcrumbs: {
      items: [
        { text: "Configuración", disabled: true },
        { text: "Cajas de Sensores", disabled: true }
      ]
    }
  }),
  computed: {
    sensorsBoxes () {
      return this.$store.state.sensors_boxes.sensors_boxes
    },
    filteredSensorsBoxes () {
      return this.filterState
        ? this.sensorsBoxes.filter(element => element.is_active.toString().includes(this.filterState))
        : this.sensorsBoxes
    }
  },
  methods: {
    deleteSensorsBoxDialog (sensorBox) {
      this.sensorsBoxToDelete = sensorBox
      this.dialog = !this.dialog
    },
    deleteSensorsBox () {
      var id = this.sensorsBoxToDelete.id
      // Check if sensors_box_data exist
      if (this.sensorsBoxToDelete.sensors_box_data) {
        // Check if sensors_box_data has data
        if (this.sensorsBoxToDelete.sensors_box_data.lenght === 0) {
          this.$store.dispatch('sensors_boxes/deleteSensorsBox', id)
            .then(() => {
              this.$toast("Caja de sensores borrada correctamente.", {
                color: "success",
                x: "center",
                y: "top",
                icon: "mdi-information"
              });
              this.loadSensorsBoxes()
            })
            .catch(error => {
              var errorToastMessage = "Ha ocurrido un error eliminando la caja de sensores."
              Util.showErrorToast(this, error, errorToastMessage);
            })
            .finally(() => {
              this.dialog = !this.dialog
            })
        } else {
          this.$toast("No puedes borrar una caja de sensores que tenga datos.", {
            color: "error",
            x: "center",
            y: "top",
            icon: "mdi-information"
          })
          this.dialog = !this.dialog
        }
      } else {
        this.$store.dispatch('sensors_boxes/deleteSensorsBox', id)
          .then(() => {
            this.$toast("Caja de sensores borrada correctamente.", {
              color: "success",
              x: "center",
              y: "top",
              icon: "mdi-information"
            });
            this.loadSensorsBoxes()
          })
          .catch(error => {
            var errorToastMessage = "Ha ocurrido un error eliminando la caja de sensores."
            Util.showErrorToast(this, error, errorToastMessage);
          })
          .finally(() => {
            this.dialog = !this.dialog
          })
      }
    },
    sensorsBoxCreate () {
      this.$router.push({ name: "sensors-create" });
    },
    sensorsBoxEdit (id) {
      this.$router.push({
        name: "sensors-edit",
        params: { id: id }
      });
    },
    sensorsBoxData (id) {
      this.$router.push({
        name: "sensors-data",
        params: { id: id }
      });
    },
    loadSensorsBoxes () {
      this.isLoadingData = true;
      this.$store.dispatch('sensors_boxes/getSensorsBoxes')
        .then(() => {
          this.authUser = true
        })
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando las cajas de sensores."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    }
  },
  async created () {
    this.loadSensorsBoxes()
    await this.$store.dispatch('sensors_boxes_image/list')
    await this.$store.dispatch('sensors_boxes_data/list')
  }
}
</script>
